<div (click)="focusInput()" class="md:flex mb-4">
  <div class="xl:w-96 lg:w-80 md:w-64">
    <label class="block text-gray-500 md:mt-2 font-bold md:text-left mb-1 md:mb-0 md:text-lg lg:text-xl" for="inline-full-name"> Thẻ </label>
  </div>
  <div class="md:w-full relative">
    <div class="border border-gray-400 rounded-md">
      <div class="flex flex-wrap">
        <div *ngFor="let tagItem of currentTags" class="m-2">
          <div class="bg-primary text-white border border-primary px-4 py-1.5 rounded-md  hover:bg-primary hover:text-white w-full">
            <button class="pr-2 border-r">{{tagItem.tag.name}}</button>
            <button (click)="eventTag.emit({value: { tag: tagItem }, type: 'remove-tag'})"
              class="md:text-lg lg:text-xl pl-4 transition duration-300 ease-in-out transform hover:-translate-y-1 hover:scale-100">
              x
            </button>
          </div>
        </div>
        <input [placeholder]="currentTags.length ? '' : 'Nhập tìm kiếm thẻ'" [formControl]="tag.formTag"
          (input)="eventTag.emit({tagElement: $event, type: 'search-tag'})" [ngClass]="currentTags.length ? '' : 'px-4'" id="fieldTag"
          class="focus:outline-none py-1.5 rounded-md" />
      </div>
    </div>
    <div [closeOnOutSide]="tags.length > 0" (clickedOutside)="closeAutoComplete()" *ngIf="tags.length;else addTag"
      [ngClass]="tags.length > 4 ? 'h-40 overflow-auto' : ''" class="absolute w-full z-30 bg-white border-l border-r border-b rounded border-gray-300">
      <div *ngFor="let tagItem of tags" class="text-primary py-1.5 hover:bg-green-100  cursor-pointer"
        (click)="eventTag.emit({value: { tag: tagItem }, type: 'add-tag'})">
        <div class="px-4 flex items-center">
          <label class="custom-checkbox">
            <input (click)="eventTag.emit({value: { tag: tagItem }, type: 'add-tag'}); tag.formTag.reset(); focusInput()" class="purple_checkbox"
              [checked]="tagItem.isChecked ? true : false" class="cursor-pointer mr-2" type="checkbox" [id]="tagItem.tagId" [name]="tagItem.name"
              [value]="tagItem.tagId" />
            <span class="cursor-pointer">{{tagItem.name}}</span>
            <span class="checkmark"></span>
          </label>
        </div>
      </div>
    </div>
    <ng-template #addTag>
      <div *ngIf="tag.newNameTag" [closeOnOutSide]="tags.length > 0" (clickedOutside)="closeAutoComplete()"
        class="absolute w-full z-30 bg-white border-l border-r border-b rounded border-gray-300">
        <div class="text-primary py-1.5 px-4 hover:bg-green-100  cursor-pointer flex" (click)="eventTag.emit({type: 'add-tag-in-database'})">
          <div class="cursor-pointer mr-4">{{tag.newNameTag}}</div>
          <div class="text-gray-500">(<fa-icon class="" [icon]="faIcon"></fa-icon> Thêm thẻ)</div>
        </div>
      </div>
    </ng-template>
    <input class="hidden" [formControl]="inputControl" />
  </div>
</div>